import Button from 'blocks/Button';
import Chip from 'components/Chip';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { TextFieldProps } from './text.interface';
import * as S from './textField.styles';

const TextField: React.FC<TextFieldProps> = ({
  id,
  control,
  defaultValue,
  error,
  message,
  label,
  placeholder,
  type = 'text',
  muliLine,
  disabled = false,
  readonly,
  inputProps = {},
  onClick,
  iconEnd,
  iconStart,
  onChange,
  onfocus,

  chips,
  className,
  fullWidth = false,
  rows = 4,
  refs,
  required = false,
  dir,
  onRemove,
  nameFile,
  setNameFile,
}) => {
  const inputRef = useRef(defaultValue);
  const { t } = useTranslation();
  useEffect(() => {
    const field = id && document.getElementById(id);
    const fieldSuggestedValue = field && (field as HTMLInputElement).value;

    if (!refs && !control && inputRef.current) {
      inputRef.current.value = defaultValue || fieldSuggestedValue || '';
    }
    // console.log(field, fieldSuggestedValue);
  }, [defaultValue]);
  const handleUploadClick = () => {
    // 👇 We redirect the click event onto the hidden input element
    inputRef.current?.click();
  };

  return (
    <S.Wrapper $fullWidth={fullWidth}>
      {label && (
        <S.Label>
          {label} {required && <S.Required>*</S.Required>}
        </S.Label>
      )}
      <S.FieldWrapper $disabled={disabled} onClick={onClick}>
        {iconStart && <S.PrependIcon>{iconStart}</S.PrependIcon>}
        {muliLine ? (
          <S.Textarea
            ref={control ? control.ref : inputRef}
            {...control}
            rows={rows}
            placeholder={placeholder}
            disabled={disabled}
            readOnly={readonly}
            defaultValue={defaultValue}
            id={id}
            style={{ direction: dir }}
            onClick={onClick}
            onChange={(e) => {
              if (onChange) onChange(e);
            }}
          />
        ) : (
          <>
            {!!chips &&
              chips.map((chip) => (
                <Chip
                  key={chip.value}
                  text={chip.title}
                  onRemove={() => {
                    if (onRemove) onRemove(chip);
                  }}
                />
              ))}

            <S.Input
              ref={refs || inputRef}
              {...control}
              placeholder={placeholder}
              type={type}
              disabled={disabled}
              readOnly={readonly}
              defaultValue={defaultValue}
              id={id}
              $type={type}
              autocomplete="none"
              className={className}
              style={{ direction: dir }}
              onChange={(e) => {
                if (onChange) onChange(e);
              }}
              onFocus={(e) => {
                onfocus && onfocus();
              }}
              multiple="multiple"
              {...inputProps}
            />
            {type === 'file' && (
              <div style={{ padding: '4px', display: 'flex', alignItems: 'center' }}>
                <S.ButtonFileb as={Button} width={100} onClick={() => handleUploadClick()}>
                  {t('pages.signup.sections.form.attachBtn')}
                </S.ButtonFileb>
                {nameFile !== t('pages.signup.sections.form.nofile') && (
                  <p
                    style={{ cursor: 'pointer', color: 'red', fontSize: '18px' }}
                    onClick={() => setNameFile(t('pages.signup.sections.form.nofile'))}
                  >
                    x
                  </p>
                )}

                <S.FileName>{nameFile && nameFile}</S.FileName>
              </div>
            )}
          </>
        )}
        {iconEnd && <S.AppendIcon>{iconEnd}</S.AppendIcon>}
      </S.FieldWrapper>
      <S.Message $error={error && error.message}>{(error && error.message) || message}</S.Message>
    </S.Wrapper>
  );
};

export default TextField;
